import { FC, memo, PropsWithChildren } from 'react';
import { HStack } from '@chakra-ui/react';

const FormRepeaterActionButtonsComponent: FC<PropsWithChildren> = ({
  children,
}) => (
  <HStack gap={2} position="absolute" right={0} top={0}>
    {children}
  </HStack>
);

export const FormRepeaterActionButtons = memo(
  FormRepeaterActionButtonsComponent,
);
